import { SET_NETWORK_STATUS } from '../actions/actionTypes';

const initialState = {
  online: navigator.onLine,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NETWORK_STATUS:
      return { online: action.data };
    default:
      return state;
  }
};

export default reducer;